import { AuthContent, AuthContext } from '@admin/components/auth'
import TextField from '@admin/components/form/textfield'
import Avatar from '@admin/components/avatar'
import Button from '@admin/components/button'
import T from '@admin/components/t'
import PropTypes from 'prop-types'
import React from 'react'

class Mobile extends React.Component {

  static contextType = AuthContext

  static propTypes = {
    context: PropTypes.shape({
      network: PropTypes.object
    }),
    account: PropTypes.object,
    token: PropTypes.string,
    onSignin: PropTypes.func
  }

  state = {
    code: null,
    sent: false,
    status: 'pending'
  }

  _handleUpdate = this._handleUpdate.bind(this)
  _handleSend = this._handleSend.bind(this)
  _handleVerify = this._handleVerify.bind(this)

  render() {
    const { account } = this.props
    const { sent } = this.state
    return (
      <AuthContent>
        <div className="maha-auth-form">
          <div className="maha-auth-content">
            { account && <Avatar user={ account } width="150" /> }
            { account && <h2>{ account.full_name }</h2> }
            <p><T text="You'll need an SMS verification code to complete your signin" /></p>
          </div>
          <div className="ui form">
            { sent &&
              <div className="field">
                <TextField { ...this._getTextField() } />
              </div>
            }
            { sent ?
              <div className="field button-field">
                <Button { ...this._getVerify() } />
              </div> :
              <div className="field button-field">
                <Button { ...this._getSend() } />
              </div>
            }
          </div>
          <div className="maha-auth-footer">
            { sent &&
              <Button { ...this._getResend() }/>
            }
          </div>
        </div>
      </AuthContent>
    )
  }

  _getPhoneField() {
    return {
      onChange: this._handleUpdate.bind(this, 'mobile_phone')
    }
  }

  _getResend() {
    return {
      label: 't(Didn\'t receive it? Resend Code)',
      className: 'link',
      handler: this._handleSend
    }
  }

  _getSend() {
    const { status } = this.state
    return {
      label: 't(Send Verification Code)',
      svg: 'mail',
      color: 'blue',
      size: 'large',
      loading: status === 'submitting',
      handler: this._handleSend
    }
  }

  _getSkip() {
    return {
      label: 't(Skip for now)',
      className: 'link',
      handler: this._handleNext
    }
  }

  _getTextField() {
    return {
      placeholder: 't(Enter Verification Code)',
      onChange: this._handleUpdate.bind(this, 'code')
    }
  }

  _getVerify() {
    const { status } = this.state
    return {
      label: 't(Verify Code)',
      color: 'blue',
      size: 'large',
      loading: status === 'submitting',
      handler: this._handleVerify
    }
  }

  _handleSend() {
    const { token } = this.props.account
    this.setState({ status: 'submitting' })
    this.props.context.network.request({
      endpoint: '/api/admin/signin/twofactor/authorize',
      method: 'POST',
      body: { token },
      onSuccess: () => {
        this.setState({ 
          status: 'pending',
          sent: true
        })
      },
      onFailure: () => {
        this.context.shake()
        this.setState({
          status: 'pending'
        })
      }
    })
  }

  _handleVerify() {
    const { account } = this.props
    const { token } = account
    const { code } = this.state
    this.setState({ sent: true, status: 'submitting' })
    this.props.context.network.request({
      endpoint: '/api/admin/signin/twofactor/verify',
      method: 'POST',
      body: { token, code },
      onSuccess: () => this.props.onSignin(account),
      onFailure: () => {
        this.context.shake()
        this.setState({
          status: 'pending'
        })
      }
    })
  }

  _handleUpdate(key, value) {
    this.setState({
      [key]: value
    })
  }

}

export default Mobile
